import { render, staticRenderFns } from "./assetsTradeDetail.vue?vue&type=template&id=d9601f14&scoped=true"
import script from "./assetsTradeDetail.vue?vue&type=script&lang=js"
export * from "./assetsTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./assetsTradeDetail.vue?vue&type=style&index=0&id=d9601f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9601f14",
  null
  
)

export default component.exports